(function () {
  if (window.nutricodeMysteryRevealCountdown) return;

  var REVEAL_TIMER_KEY = 'mystery_offer_reveal_timer_v1';
  var REVEAL_TIMER_DURATION_KEY = 'mystery_offer_reveal_timer_duration_v1';
  var DEFAULT_DURATION_SEC = 60 * 60;

  var mounts = [];
  var tickInterval = null;
  var secondsLeft = 0;
  var onExpireCallbacks = [];
  var expireFired = false;

  function getStoredStart() {
    try {
      var stored = localStorage.getItem(REVEAL_TIMER_KEY);
      return stored ? parseInt(stored, 10) : null;
    } catch (e) {
      return null;
    }
  }

  function getStoredDuration() {
    try {
      var stored = localStorage.getItem(REVEAL_TIMER_DURATION_KEY);
      if (stored) {
        var n = parseInt(stored, 10);
        if (n > 0) return n;
      }
    } catch (e) {}
    return DEFAULT_DURATION_SEC;
  }

  function getElapsedSec(startTime) {
    if (!startTime) return null;
    return Math.floor((Date.now() - startTime) / 1000);
  }

  function computeSecondsLeft() {
    var start = getStoredStart();
    if (!start) return null;
    var duration = getStoredDuration();
    var elapsed = getElapsedSec(start);
    if (elapsed === null) return null;
    return Math.max(0, duration - elapsed);
  }

  function updateMount(root, sec) {
    var safeSec = Math.max(0, Number(sec) || 0);
    var map;
    var hoursEl = root.querySelector('[data-mop-reveal-digit="hours-tens"]');

    if (hoursEl) {
      var hours = Math.floor(safeSec / 3600);
      var minutes = Math.floor((safeSec % 3600) / 60);
      var seconds = safeSec % 60;
      map = {
        'hours-tens': Math.floor(hours / 10),
        'hours-ones': hours % 10,
        'minutes-tens': Math.floor(minutes / 10),
        'minutes-ones': minutes % 10,
        'seconds-tens': Math.floor(seconds / 10),
        'seconds-ones': seconds % 10
      };
    } else {
      var totalMinutes = Math.floor(safeSec / 60);
      var secs = safeSec % 60;
      map = {
        'minutes-tens': Math.floor(totalMinutes / 10),
        'minutes-ones': totalMinutes % 10,
        'seconds-tens': Math.floor(secs / 10),
        'seconds-ones': secs % 10
      };
    }

    Object.keys(map).forEach(function (key) {
      var el = root.querySelector('[data-mop-reveal-digit="' + key + '"]');
      if (el) el.textContent = String(map[key]);
    });
  }

  function updateAll() {
    mounts.forEach(function (root) {
      updateMount(root, secondsLeft);
    });
  }

  function stopTick() {
    if (tickInterval) {
      clearInterval(tickInterval);
      tickInterval = null;
    }
  }

  function fireExpire() {
    if (expireFired) return;
    expireFired = true;
    stopTick();
    secondsLeft = 0;
    updateAll();
    onExpireCallbacks.slice().forEach(function (fn) {
      try {
        fn();
      } catch (e) {}
    });
    window.dispatchEvent(new CustomEvent('nutricode:mystery-reveal-expired'));
  }

  function tick() {
    /*
      Re-read the stored start every tick instead of decrementing: background tabs
      throttle or freeze timers, so a counter falls behind the real expiry that
      checkout uses (isExpired) and the page keeps showing a discount checkout drops.
    */
    var computed = computeSecondsLeft();
    secondsLeft = computed !== null ? computed : secondsLeft - 1;
    if (secondsLeft <= 0) {
      fireExpire();
      return;
    }
    updateAll();
  }

  /* Tab shown again or page restored from bfcache: catch up with the real clock now. */
  function resyncWithClock() {
    if (expireFired || !getStoredStart()) return;
    tick();
  }

  function syncSecondsLeft() {
    var computed = computeSecondsLeft();
    if (computed === null) return false;
    secondsLeft = computed;
    return true;
  }

  function ensureTicking() {
    expireFired = false;
    if (!syncSecondsLeft()) return false;
    updateAll();
    if (secondsLeft <= 0) {
      fireExpire();
      return false;
    }
    stopTick();
    tickInterval = setInterval(tick, 1000);
    return true;
  }

  function mount(root, options) {
    if (!root) return;
    var isNew = mounts.indexOf(root) === -1;
    if (isNew) mounts.push(root);
    if (isNew && options && typeof options.onExpire === 'function') {
      onExpireCallbacks.push(options.onExpire);
    }
    if (getStoredStart()) {
      ensureTicking();
    } else {
      updateMount(root, getStoredDuration());
    }
  }

  function unmount(root) {
    mounts = mounts.filter(function (r) {
      return r !== root;
    });
    if (mounts.length === 0) stopTick();
  }

  function isExpired() {
    var start = getStoredStart();
    if (!start) return false;
    var left = computeSecondsLeft();
    return left === null || left <= 0;
  }

  function hasStarted() {
    return getStoredStart() !== null;
  }

  function startFromNow() {
    expireFired = false;
    try {
      localStorage.setItem(REVEAL_TIMER_KEY, String(Date.now()));
      localStorage.setItem(REVEAL_TIMER_DURATION_KEY, String(DEFAULT_DURATION_SEC));
    } catch (e) {}
    secondsLeft = DEFAULT_DURATION_SEC;
    updateAll();
    stopTick();
    tickInterval = setInterval(tick, 1000);
  }

  function startOrResume() {
    var start = getStoredStart();
    if (!start || isExpired()) {
      startFromNow();
      return;
    }
    ensureTicking();
  }

  function mountAllPending() {
    document.querySelectorAll('[data-mop-reveal-countdown-root]').forEach(function (root) {
      mount(root);
    });
  }

  window.nutricodeMysteryRevealCountdown = {
    mount: mount,
    unmount: unmount,
    startFromNow: startFromNow,
    startOrResume: startOrResume,
    computeSecondsLeft: computeSecondsLeft,
    getStoredStart: getStoredStart,
    hasStarted: hasStarted,
    isExpired: isExpired,
    getSecondsLeft: function () {
      return secondsLeft;
    }
  };

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') resyncWithClock();
  });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) resyncWithClock();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAllPending);
  } else {
    mountAllPending();
  }
})();
